import HomepageTemplate from "../../../../src/components/Homepage";
import * as React from 'react';
export default {
  HomepageTemplate,
  React
};